<template>
    <auth>
        <div class="row">
            <div class="col-md-6 offset-md-3 text-center">
                <form @submit.stop.prevent="login">
                    <div class="form-group row">
                        <label for="username" class="col-sm-2 col-form-label"
                            >E-mail</label
                        >
                        <div class="col-sm-10">
                            <input
                                type="email"
                                v-model="user.email"
                                class="form-control"
                                id="email"
                                name="email"
                            />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="password" class="col-sm-2 col-form-label">{{
                            $t("message.password")
                        }}</label>
                        <div class="col-sm-10">
                            <input
                                type="password"
                                v-model="user.password"
                                class="form-control"
                                id="password"
                                name="password"
                            />
                        </div>
                    </div>

                    <hr />

                    <div class="form-group row">
                        <div class="col-sm-10">
                            <button
                                type="submit"
                                :disabled="!user.email || !user.password"
                                class="btn btn-primary"
                            >
                                Login
                            </button>
                            &nbsp;&nbsp;&nbsp;
                            <button
                                type="button"
                                @click="clear()"
                                class="btn btn-warning"
                            >
                                Limpar
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-10 text-center">
                            <router-link :to="'/signup'">
                                Não tem conta? Clique aqui para se cadastrar
                            </router-link>
                            <br />
                            <router-link :to="'/recover'">
                                Esqueceu a senha? Clique aqui para recuperar
                            </router-link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </auth>
</template>

<script>
/* eslint-disable no-console */
//import axios from 'axios';
import Lockr from 'lockr';
import Swal from "sweetalert2";
import LogoImage from "./../assets/logo.png";
import Auth from "./../layouts/Auth";
import { loginAction } from "./../configs/services";
import Bus from "./../configs/bus";

export default {
    name: "login",
    components: {
        Auth
    },
    data() {
        return {
            logo: LogoImage,
            user: {
                email: "",
                password: ""
            }
        };
    },
    methods: {
        async login() {
            let vm = this;
            Bus.$emit("toggle", null);

            loginAction(this.user)
                .then(item => {
                    console.log(item);
                    if (!item.error) {
                        Lockr.set('token', item.token)

                        Lockr.set('user', item.user)
                        
                        vm.$router.push({ name: "Home" });
                    } else {
                        Swal.fire("Erro!", item.error, "error");
                    }
                })
                .catch(this.errorHandler)
                .then(function() {
                    // always executed
                    Bus.$emit("toggle", null);
                });
        },
        clear() {
            this.user = {
                email: "",
                password: ""
            };
        }
    }
};
</script>
